import { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  EmailInbox, 
  EmailSend, 
  EmailReceipts
} from '../components/email';

type TabType = 'inbox' | 'send' | 'receipts';


export default function FidexEmail() {
  const [activeTab, setActiveTab] = useState<TabType>('inbox');

  const tabs = [
    {
      id: 'inbox' as TabType,
      label: 'Boîte de réception',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
        </svg>
      ),
    },
    {
      id: 'send' as TabType,
      label: "Envoi d'email",
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
        </svg>
      ),
    },
    {
      id: 'receipts' as TabType,
      label: 'Accusé de réception',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
    },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'inbox':
        return <EmailInbox />;
      case 'send':
        return <EmailSend />;
      case 'receipts':
        return <EmailReceipts />;
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-white to-yellow-100 p-4 sm:p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <Link to="/" className="btn btn-ghost btn-sm hover:bg-yellow-100">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Retour
          </Link>
          <div className="flex items-center gap-3 bg-gradient-to-r from-yellow-400 to-yellow-500 text-black px-6 py-3 rounded-xl shadow-lg">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            <h1 className="text-lg font-bold">Fidex Email</h1>
          </div>
        </div>

        {/* Tabs Navigation */}
        <div className="card bg-white shadow-xl mb-6">
          <div className="card-body p-0">
            <div className="tabs tabs-boxed bg-transparent p-2 gap-2 flex-wrap">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`tab tab-lg gap-2 flex-1 min-w-fit font-semibold transition-all ${
                    activeTab === tab.id
                      ? 'tab-active bg-warning text-black shadow-md'
                      : 'hover:bg-yellow-50'
                  }`}
                >
                  {tab.icon}
                  <span className="hidden sm:inline">{tab.label}</span>
                  <span className="sm:hidden">
                    {tab.id === 'inbox' && 'Boîte'}
                    {tab.id === 'send' && 'Envoi'}
                    {tab.id === 'receipts' && 'Accusés'}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Tab Content */}
        <div className="animate-fadeIn">
          {renderContent()}
        </div>
      </div>
    </div>
  );
}
